module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/name/prefix.js
// module id = 1061
// module chunks = 1